import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../pages/HomePage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/:token', name: 'home', component: HomePage },
  
]

const router = new VueRouter({
  routes
})

export default router
